import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const NAV = [
  { id: "services", label: "Services" },
  { id: "pricing", target: "contact", label: "Pricing" },
  { id: "about", label: "About" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (n) => {
    setOpen(false);
    const targetId = typeof n === "string" ? n : n.target || n.id;
    const el = document.getElementById(targetId);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-cream/85 backdrop-blur-xl border-b border-border/60"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="brand-logo"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center group"
        >
          <img
            src="/brand/logo.png"
            alt="DSO Books Solutions Inc."
            className="h-10 md:h-12 w-auto select-none"
            draggable="false"
          />
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {NAV.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => go(n)}
              className="text-sm text-ink/80 hover:text-navy link-underline transition-colors"
            >
              {n.label}
            </button>
          ))}
          <button
            data-testid="header-cta-consult"
            onClick={() => go("contact")}
            className="bg-navy text-cream px-5 py-2.5 text-sm tracking-wide hover:bg-navy2 transition-colors"
          >
            Book Consultation
          </button>
        </nav>

        <button
          className="md:hidden p-2 -mr-2"
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6 text-navy" /> : <Menu className="h-6 w-6 text-navy" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-cream border-t border-border" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-3">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`mobile-nav-${n.id}`}
                onClick={() => go(n)}
                className="text-left text-ink py-2 border-b border-border/60"
              >
                {n.label}
              </button>
            ))}
            <button
              data-testid="mobile-cta-consult"
              onClick={() => go("contact")}
              className="mt-2 bg-navy text-cream px-5 py-3 text-sm"
            >
              Book Consultation
            </button>
          </div>
        </div>
      )}
    </header>
  );
}
